import React, { FC } from 'react';
import styles from './Actions.module.scss';
import { connect } from 'react-redux';
import { AppDispatch } from '../../../../store';
import { RootState } from '../../../../rootReducer';
import Button from '../../../Shared/Button/Button';

type ActionsProps = {
  isLoading: boolean;
  isDisabled: boolean;
  onNext?: () => void;
  onPrevious?: () => void;
  onDone?: () => void;
};

type Props = {
  currentPage: number;
  totalNumber: number;
};

const Actions: FC<Props & ActionsProps> = ({ isLoading, isDisabled, currentPage, totalNumber, onNext, onPrevious, onDone }) => {
  return (
    <div className={styles.stepsAction}>
      {currentPage > 0 && onPrevious && <Button type='button' onClick={onPrevious} disabled={false} title='Previous' />}
      {currentPage === totalNumber - 1 && onDone && (
        <Button type='button' onClick={onDone} disabled={isLoading} title='Done' style={{ marginLeft: 8 }} isLoading={isLoading} />
      )}
      {currentPage < totalNumber - 1 && onNext && (
        <Button type='button' onClick={onNext} disabled={isDisabled} title='Next' style={{ marginLeft: 'auto' }} />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps: ActionsProps) => ({
  currentPage: state.annotationStandardForm.currentPage,
  totalNumber: state.annotationStandardForm.totalNumberOfPages,
  ...ownProps
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
